import GroupSignUpForm from "../Components/GroupAccountForm";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Session from 'react-session-api'; // this also appears to be used but not imported
import React from "react";
import '../Styles/GroupSignUp.scss';
import {Helmet} from "react-helmet";
import GroupAccountForm from "../Components/GroupAccountForm";

function CreateGroupAccount() {

   const [error, setError]     = useState(false)
   
   const navigate = useNavigate()

   const [groupAccountInformation, setGroupAccountInformation] = useState({
      groupName: '',
      groupAdmin: '',
      groupEmail: '',
      groupPassword: '',
      groupConfirmPassword: '',
      groupAddressOne: '',
      groupAddressTwo: '',
      groupCity: '',
      groupState: '',
      groupCountry: '',
      groupZip: '',
      groupPhone: null,
   })

   // Create group account
   const handleSubmit = async () => {
      try {
            const apiResponse = await fetch('/api/groupcreateaccount', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               groupName: groupAccountInformation.groupName,
               admin: groupAccountInformation.groupAdmin, 
               email: groupAccountInformation.groupEmail,
               password: groupAccountInformation.groupPassword,
               addressLineOne: groupAccountInformation.groupAddressOne,
               addressLineTwo: groupAccountInformation.groupAddressTwo,
               city: groupAccountInformation.groupCity,
               state: groupAccountInformation.groupState,
               country: groupAccountInformation.groupCountry,
               zip: groupAccountInformation.groupZip,
               phone: groupAccountInformation.groupPhone
           })
         })

         const registerResult = await apiResponse.json();
         console.log("registrationResult", registerResult)
        

         if (apiResponse.status === 400 || apiResponse.status === 500) {
            throw new Error(registerResult.errors[0].msg);
         }

         // Log into the account
         const apiResponse2 = await fetch('/api/grouplogin', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               email: groupAccountInformation.groupEmail,
               password: groupAccountInformation.groupPassword
           })
         })

         const loginResult = await apiResponse2.json();

         if (apiResponse2.status === 400 || apiResponse2.status === 500) {
            throw new Error(loginResult.errors[0].msg);
         }

         Session.set("isAuth", apiResponse2.ok.toString())
         Session.set("accountType", "group")

         navigate('/groupaccount');
      }
      catch (error) {
         setError(error.message);
      }
   }
   return (
      <div>
         <div className="groupSignUpForm">
               <Helmet>
                  <title>Group Sign Up - Camp Connect</title>
               </Helmet>
               <GroupAccountForm
               groupAccountInformation={groupAccountInformation}
               setGroupAccountInformation={setGroupAccountInformation}
               handleSubmit={handleSubmit}
               />
         </div>

         <div className="groupBackgroundTaller">
         </div>
      </div>
   )
};
export default CreateGroupAccount;
